import { ICON_TYPES } from '../constants';

export const TwitterLogoIcon = (): JSX.Element => {
  return (
    <svg
      width="28"
      height="29"
      viewBox="0 0 28 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect y="0.5" width="28" height="28" rx="14" fill="black" />
      <path
        d="M8 8.60503H11.5491L14.8296 13.1885L18.9131 8.5L19.8833 8.5175L15.3133 13.8479L20 20.395H16.4523L13.356 16.1236L9.57347 20.5H8.6187L12.8863 15.4993L8 8.60503ZM11.2144 9.28191H9.34005L16.839 19.7006H18.6796L11.2144 9.28191Z"
        fill="white"
      />
    </svg>
  );
};

TwitterLogoIcon.iconType = ICON_TYPES.TWITTER_LOGO;
